/**
 * Created by Administrador on 11/7/2016.
 */
(function(){
    'use strict';

    'use strict';

    var regulationDates = {
        templateUrl: 'app/configGeneral/rates/rule/templates/dates/check-box.html',
        controller: regulationDatesController,
        controllerAs: 'vm',
        bindings: {
            target: '@',
            label: '@',
            ngModel: '=',
            selectCheckbox: '=',
            checkRequire: '=',
            onChangeEvent: '&'
        }
    };

    angular
        .module('completeAir')
        .component('regulationDates', regulationDates);

    regulationDatesController.$inject = ['$timeout'];

    function regulationDatesController($timeout) {
        var vm = this;

        vm.someSelected = function (object) {
            return Object.keys(object).some(function (key) {
                return object[key];
            });
        }

        vm.handleChangeEvent = function(){
            $timeout(function () {
                vm.onChangeEvent();
            }, 50);
        }
    }
})();
